exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".course-view img{width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/views/CourseView/CourseView.less
 ** module id = 514
 ** module chunks = 1
 **/